export default {"src":"/_next/static/media/delete_x_icon.0ac17882.svg","height":16,"width":16};